import ACTIONS from '../actions.js'

export function useSelectionActions(dispatch) {
  return {
    setClient: (
      clientId,
      _personal,
      authTypes,
      userSecretQuestionList = null,
    ) =>
      dispatch({
        type: ACTIONS.SET_CLIENT,
        payload: { clientId, _personal, authTypes, userSecretQuestionList },
      }),
    setSelectedFolder: value =>
      dispatch({ type: ACTIONS.SET_SELECTED_FOLDER, value }),
  }
}

export default useSelectionActions
